import type { Modality } from "./modality";

/**
 * The two ways a skill spoke is named to the learner.
 *
 * They are separate message families on purpose: the radar and the board name
 * the skill as a noun ("Reading", "Leitura"), while the request form names the
 * act as a verb ("Read", "Ler"). Six call sites built these keys by hand, so
 * the prefixes travelled with nothing to check them - and getTranslator echoes
 * an unknown key back, so a missing label renders as
 * "curriculum.radar.modality.LISTENING" rather than failing.
 */
const NOUN_PREFIX = "curriculum.radar.modality";
const VERB_PREFIX = "curriculum.request.modality";

/** The skill as a noun, for the radar, the board and the agent's chips. */
export function modalityNounKey(modality: Modality): string {
  return `${NOUN_PREFIX}.${modality}`;
}

/** The skill as a verb, for asking the learner what they want to practice. */
export function modalityVerbKey(modality: Modality): string {
  return `${VERB_PREFIX}.${modality}`;
}
